module.exports = __webpack_public_path__ + "static/mysa-mattress-5-3a5a29b7b765fc69726185d0582eff79.webp";